import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { OpenCardAddContractAction } from './card-add-contract-dialog.action';
import { PaycellService } from '../services/paycell.service';

/* @ngInject */
export default class CardAddContractDialogController implements ActionHandler {
  private dialogElement;
  private contract: string;

  protected approve: () => any;

  constructor(
    private $element,
    private $sce,
    private $translate,
    private actionDispatcher: ActionDispatcherService,
    private paycellService: PaycellService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#card-add-contract-dialog')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenCardAddContractAction) {
      this.approve = action.onApprove;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.paycellService
      .getContractByKey('card_storage_contract')
      .then(contract => {
        this.contract = this.$sce.trustAsHtml(contract);
        this.dialogElement.open();
      });
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }

  public onApprove() {
    this.approve();
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/card-add-contract-dialog/card-add-contract-dialog.controller.ts